import Webapi from './webapi'

const webapi = () => new Webapi()

export const auth = () =>
    webapi()
        .path('auth0')
        .get()
